import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaUsers, FaUserPlus, FaMoneyBillWave, FaChartLine,
  FaSearch, FaEdit, FaCreditCard, FaHistory,
  FaTachometerAlt, FaCheckCircle, FaTimesCircle,
  FaChartBar, FaUserShield, FaFileContract,
  FaCog, FaBell, FaSignOutAlt, FaGlobe,
  FaChevronDown, FaChevronLeft, FaChevronRight,
  FaLightbulb, FaRobot, FaHandHoldingUsd,
  FaProjectDiagram, FaRegNewspaper, FaReceipt,
  FaUser, FaPlus, FaTrash, FaEye, FaBars, FaTimes, FaCalendarAlt,FaKey, FaClock
} from 'react-icons/fa';
import AdminProofs from './AdminProofs';
import AddProduct from './AddProduct';
import AdminAddFeed from './AdminAddFeed';
import AddRewards from './AddRewards';
import DailyRewards from './DailyRewards';
import InvestmentManagement from './InvestmentManagement';
import PasswordResetModal from './PasswordResetModal';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import { useAuth } from '../security/security/AuthContext';
import { FaWhatsapp } from 'react-icons/fa';
import ExpenseManagement from './ExpenseManagement';
import './admin.css';


import { CSVLink } from 'react-csv';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Admin = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [selectedUser, setSelectedUser] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [editedBalance, setEditedBalance] = useState('');
  const [notifications, setNotifications] = useState(3);
  const [deposits, setDeposits] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(1550);
  const { userDetails, token, updateUserDetails } = useAuth();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [securityCode, setSecurityCode] = useState('');
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportError, setExportError] = useState('');
  const [exportFormat, setExportFormat] = useState('csv');


  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const authContext = useAuth();
  const [approvedWithdrawals, setApprovedWithdrawals] = useState(0);
  
    const indexOfLastItem = (currentPage + 1) * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

    const [showPasswordReset, setShowPasswordReset] = useState(false);
    const [selectedUserForPassword, setSelectedUserForPassword] = useState(null);
  

  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 992);


  const [dashboardStats, setDashboardStats] = useState({
    totalUsers: 0,
    todaySignups: 0,
    todayTransactions: 0,
    yesterdayTransactions: 0,
    totalRevenue: 0,
    yesterdaySignups: 0,
    totalApprovedWithdrawals: 0
  });
  
  const [recentTransactions, setRecentTransactions] = useState([]);


  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 992);
      if (window.innerWidth > 992) {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


  const handleMenuClick = (tab) => {
    setActiveTab(tab);
    if (isMobileView) {
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
      fetchApprovedWithdrawals();
    }, []);


  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        const [statsResponse, transactionsResponse, withdrawalsResponse] = await Promise.all([
          axios.get('https://api.globallequityfinance.com/api/admin/dashboard/stats', {
            headers: { Authorization: token }
          }),
          axios.get('https://api.globallequityfinance.com/api/admin/transactions/recent', {
            headers: { Authorization: token }
          }),
          axios.get('https://api.globallequityfinance.com/api/admin/withdrawals?status=APPROVED', {
            headers: { Authorization: token }
          })
        ]);
    
        const totalApprovedWithdrawals = withdrawalsResponse.data
          .reduce((sum, withdrawal) => sum + withdrawal.requestedAmount, 0);
    
        // Sort recent transactions by ID in descending order
        const sortedTransactions = transactionsResponse.data
          .sort((a, b) => b.id - a.id);
    
        setDashboardStats({
          ...statsResponse.data,
          totalApprovedWithdrawals
        });
        setRecentTransactions(sortedTransactions);
      } catch (err) {
        setError('Failed to load dashboard data');
        console.error('Error fetching dashboard data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);
  

  function logout() {
    authContext.logout();
    navigate('/main/admin/1/login/main');
  }

  function whatsapp() {
    navigate('/whatsapp');
  }

  useEffect(() => {
    fetchDeposits();
    fetchWithdrawals();
  }, [currentPage]);

  useEffect(() => {
    if (activeTab === 'users') {
      fetchUsers();
    }
  }, [activeTab]);

  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get('https://api.globallequityfinance.com/api/admin/users', {
        headers: { Authorization: token }
      });
  
      // Sort the users by ID in descending order
      const sortedUsers = response.data.sort((a, b) => b.id - a.id);
  
      setUsers(sortedUsers);
      setFilteredUsers(sortedUsers);
    } catch (error) {
      setError('Failed to fetch users');
      console.error('Error fetching users:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (!searchTerm.trim()) {
      setFilteredUsers(users);
      return;
    }

    const searchTermLower = searchTerm.toLowerCase();
    const filtered = users.filter(user => 
      user.fullName.toLowerCase().includes(searchTermLower) ||
      user.email.toLowerCase().includes(searchTermLower) ||
      user.mobile.includes(searchTerm)
    );
    setFilteredUsers(filtered);
  };


  const formatMobileForExport = (mobile) => {
    if (!mobile) return 'N/A';
    
    // Clean the number by removing any non-digit characters
    const cleanNumber = mobile.replace(/\D/g, '');
    
    // If number starts with 254, remove 254 and add 0
    if (cleanNumber.startsWith('254')) {
      return `0${cleanNumber.slice(3)}`;
    }
    
    // If already starts with 07 or 01, keep as is
    if (cleanNumber.startsWith('07') || cleanNumber.startsWith('01')) {
      return cleanNumber;
    }
    
    // For any other format, just return as is
    return cleanNumber;
  };


  const handleExportContacts = () => {
    // Extract mobile numbers and format them according to the requirements
    const contacts = users.map(user => ({
      Mobile: formatMobileForExport(user.mobile)
    }));
    
    // Create Excel file
    const worksheet = XLSX.utils.json_to_sheet(contacts);
    
    // Set column width
    const columnWidths = [
      { wch: 20 }  // Mobile
    ];
    worksheet['!cols'] = columnWidths;
    
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'User Mobile Numbers');
    
    // Generate Excel file and download
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(data, `vision_tech_mobile_numbers_${new Date().toISOString().split('T')[0]}.xlsx`);
  };


  const renderExportModal = () => (
    <div 
      className="adminpage-modal-overlay"
      onClick={(e) => {
        // Only close if clicking directly on the overlay (not its children)
        if (e.target === e.currentTarget) {
          setShowExportModal(false);
          setSecurityCode('');
          setExportError('');
        }
      }}
    >
      <div 
        className="adminpage-modal"
        onClick={(e) => e.stopPropagation()} // Prevent clicks inside modal from closing it
      >
        <div className="adminpage-modal-header">
          <h5>Export Mobile Numbers</h5>
          <button 
            className="adminpage-modal-close" 
            onClick={() => {
              setShowExportModal(false);
              setSecurityCode('');
              setExportError('');
            }}
          >×</button>
        </div>
        <div className="adminpage-modal-body">
          <div className="adminpage-form-group">
            <label>Security Code</label>
            <input 
              type="password" 
              value={securityCode} 
              onChange={(e) => setSecurityCode(e.target.value)}
              placeholder="Enter security code"
            />
            {exportError && <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>{exportError}</div>}
          </div>
          <div className="adminpage-form-group">
            <label>Export Format</label>
            <select 
              value={exportFormat} 
              onChange={(e) => setExportFormat(e.target.value)}
            >
              <option value="csv">CSV</option>
              <option value="excel">Excel</option>
            </select>
          </div>
        </div>
        <div className="adminpage-modal-footer">
          <button 
            className="adminpage-btn-light" 
            onClick={() => setShowExportModal(false)}
          >
            Cancel
          </button>
          <button 
            className="adminpage-btn-primary" 
            onClick={handleExportContacts}
          >
            Export Mobile Numbers
          </button>
        </div>
      </div>
    </div>
  );

 

  const handleUpdateUser = async (userId, updatedData) => {
    try {
      setIsLoading(true);
      const requestData = {
        ...updatedData,
        isEnabled: true, // Always send true for enabled
        mobile: selectedUser.mobile,
        wallet: parseFloat(updatedData.wallet),
        accountStatus: updatedData.accountStatus
      };
  
      const response = await axios.put(
        `https://api.globallequityfinance.com/api/admin/users/${userId}`,
        requestData,
        { headers: { Authorization: token } }
      );
  
      // Update the local state with the response data
      const updatedUsers = users.map(user =>
        user.id === userId ? {
          ...user,
          ...response.data,
          isEnabled: true // Ensure it's always enabled
        } : user
      );
  
      setUsers(updatedUsers);
      setFilteredUsers(updatedUsers);
      setEditMode(false);
      setSelectedUser(null);
  
      alert('User updated successfully');
    } catch (error) {
      setError('Failed to update user: ' + (error.response?.data?.message || error.message));
      console.error('Error updating user:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  // Updated handleEditUser function
  const handleEditUser = (user) => {
    setSelectedUser({
      ...user,
      mobile: user.mobile || '',
      isEnabled: true // Always set to true
    });
    setEditedBalance(user.wallet?.toString() || '0');
    setEditMode(true);
  };


  // Updated fetchDeposits function with error handling and data validation
  const fetchDeposits = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://api.globallequityfinance.com/api/admin/deposits?page=${currentPage}&size=${itemsPerPage}`, 
        { headers: { Authorization: token } }
      );
      
      // Validate and transform the data, then sort by ID in descending order
      const validatedDeposits = response.data
        .map(deposit => ({
          ...deposit,
          amount: deposit.amount || 0,
          transactionDate: deposit.transactionDate || new Date().toISOString(),
          status: deposit.status || 'PENDING',
          mpesaReceiptNumber: deposit.mpesaReceiptNumber || 'N/A',
          phoneNumber: deposit.phoneNumber || 'N/A'
        }))
        .sort((a, b) => b.id - a.id); // Sort in descending order
      
      setDeposits(validatedDeposits);
    } catch (error) {
      console.error('Error fetching deposits:', error);
      setError('Failed to fetch deposits');
      setDeposits([]);
    } finally {
      setLoading(false);
    }
  };


  const fetchApprovedWithdrawals = async () => {
    try {
      const response = await axios.get('https://api.globallequityfinance.com/api/admin/withdrawals?status=APPROVED', {
        headers: { Authorization: token }
      });
      const totalWithdrawals = response.data.reduce((sum, withdrawal) => sum + withdrawal.amountToReceive, 0);
      setApprovedWithdrawals(totalWithdrawals);
    } catch (error) {
      console.error('Error fetching approved withdrawals:', error);
    }
  };
  

  // Updated fetchWithdrawals function with error handling and data validation
  const fetchWithdrawals = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://api.globallequityfinance.com/api/admin/withdrawals?page=${currentPage}&size=${itemsPerPage}`, 
        { headers: { Authorization: token } }
      );
      
      // Validate and transform the data, then sort by ID in descending order
          const validatedWithdrawals = response.data
      .map(withdrawal => ({
        ...withdrawal,
        requestedAmount: withdrawal.requestedAmount || 0,
        amountToReceive: withdrawal.amountToReceive || 0,
        requestTime: withdrawal.requestTime || new Date().toISOString(),
        withdrawalStatus: withdrawal.withdrawalStatus || 'PENDING',
        orderNumber: withdrawal.orderNumber || 'N/A',
        email: withdrawal.email || 'N/A',
        mobile: withdrawal.mobile || 'N/A'
      }))
      .sort((a, b) => b.id - a.id); // Sort in descending order
          
      setWithdrawals(validatedWithdrawals);
    } catch (error) {
      console.error('Error fetching withdrawals:', error);
      setError('Failed to fetch withdrawals');
      setWithdrawals([]);
    } finally {
      setLoading(false);
    }
  };

  
  const handleDeleteTransaction = async (id) => {
    if (window.confirm('Are you sure you want to delete this transaction?')) {
      try {
        await axios.delete(`https://api.globallequityfinance.com/api/admin/transactions/${id}`, {
          headers: { Authorization: token }
        });
        fetchDeposits(); // Refresh the list
      } catch (error) {
        console.error('Error deleting transaction:', error);
      }
    }
  };
  
  const handleApproveWithdrawal = async (id) => {
    try {
      await axios.put(`https://api.globallequityfinance.com/api/admin/withdrawals/${id}/approve`, null, {
        headers: { Authorization: token }
      });
      fetchWithdrawals(); // Refresh the list
    } catch (error) {
      console.error('Error approving withdrawal:', error);
    }
  };
  
  const handleDeclineWithdrawal = async (id) => {
    if (window.confirm('Are you sure you want to decline this withdrawal? The amount will be refunded to the user.')) {
      try {
        await axios.put(`https://api.globallequityfinance.com/api/admin/withdrawals/${id}/decline`, null, {
          headers: { Authorization: token }
        });
        fetchWithdrawals(); // Refresh the list
      } catch (error) {
        console.error('Error declining withdrawal:', error);
      }
    }
  };


  // Mock data
  useEffect(() => {
    setUsers([
      { id: 1, name: 'John Doe', email: 'john@example.com', wallet: 5000, joinDate: '2024-10-29', status: 'active', investmentPlan: 'Premium', totalInvestments: 25000 },
      { id: 2, name: 'Jane Smith', email: 'jane@example.com', wallet: 3000, joinDate: '2024-10-30', status: 'active', investmentPlan: 'Standard', totalInvestments: 15000 }
    ]);

    setDeposits([
      { id: 1, userId: 1, amount: 1000, date: '2024-10-30', status: 'completed', method: 'Bank Transfer', reference: 'DEP001' },
      { id: 2, userId: 2, amount: 2000, date: '2024-10-30', status: 'pending', method: 'Credit Card', reference: 'DEP002' }
    ]);

    setWithdrawals([
      { id: 1, userId: 1, amount: 500, date: '2024-10-30', status: 'pending', method: 'Bank Transfer', reference: 'WIT001' },
      { id: 2, userId: 2, amount: 1000, date: '2024-10-30', status: 'completed', method: 'Wire Transfer', reference: 'WIT002' }
    ]);
  }, []);



  const handlePasswordReset = async (userId, newPassword) => {
    try {
      await axios.put(
        `https://api.globallequityfinance.com/api/admin/users/${userId}/reset-password`,
        { newPassword },
        { headers: { Authorization: token } }
      );
      // Show success message or handle UI updates
    } catch (error) {
      console.error('Error resetting password:', error);
      throw error; // Let the modal component handle the error
    }
  };
  
  const renderDashboard = () => (
    <div className="forex-pesa-admin-dashboard">
      <div className="forex-pesa-admin-stats-grid">
        <div className="forex-pesa-admin-stat-card forex-pesa-admin-gradient-primary">
          <div className="forex-pesa-admin-stat-content">
            <div className="forex-pesa-admin-stat-info">
              <h6>Total Users</h6>
              <h2>{dashboardStats.totalUsers.toLocaleString()}</h2>
              <div className="forex-pesa-admin-stat-trend">
                <span className="forex-pesa-admin-trend-up">+{dashboardStats.todaySignups} today</span>
              </div>
            </div>
            <div className="forex-pesa-admin-stat-icon">
              <FaUsers />
            </div>
          </div>
        </div>
  
        <div className="forex-pesa-admin-stat-card forex-pesa-admin-gradient-secondary">
          <div className="forex-pesa-admin-stat-content">
            <div className="forex-pesa-admin-stat-info">
              <h6>Today's Signups</h6>
              <h2>{dashboardStats.todaySignups}</h2>
              <div className="forex-pesa-admin-stat-trend">
                <span className={dashboardStats.todaySignups >= dashboardStats.yesterdaySignups ? 
                  "forex-pesa-admin-trend-up" : "forex-pesa-admin-trend-down"}>
                  {dashboardStats.todaySignups >= dashboardStats.yesterdaySignups ? "↑" : "↓"} 
                  vs yesterday
                </span>
              </div>
            </div>
            <div className="forex-pesa-admin-stat-icon">
              <FaUserPlus />
            </div>
          </div>
        </div>
  
        <div className="forex-pesa-admin-stat-card forex-pesa-admin-gradient-tertiary">
          <div className="forex-pesa-admin-stat-content">
            <div className="forex-pesa-admin-stat-info">
              <h6>Yesterday's Signups</h6>
              <h2>{dashboardStats.yesterdaySignups || 0}</h2>
            </div>
            <div className="forex-pesa-admin-stat-icon">
              <FaCalendarAlt />
            </div>
          </div>
        </div>
  
        <div className="forex-pesa-admin-stat-card forex-pesa-admin-gradient-success">
          <div className="forex-pesa-admin-stat-content">
            <div className="forex-pesa-admin-stat-info">
              <h6>Yesterday's Transactions</h6>
              <h2>KSH {dashboardStats.yesterdayTransactions.toLocaleString()}</h2>
            </div>
            <div className="forex-pesa-admin-stat-icon">
              <FaHistory />
            </div>
          </div>
        </div>
  
        <div className="forex-pesa-admin-stat-card forex-pesa-admin-gradient-info">
          <div className="forex-pesa-admin-stat-content">
            <div className="forex-pesa-admin-stat-info">
              <h6>Today's Transactions</h6>
              <h2>KSH {dashboardStats.todayTransactions.toLocaleString()}</h2>
              <div className="forex-pesa-admin-stat-trend">
                <span className={dashboardStats.todayTransactions >= dashboardStats.yesterdayTransactions ? 
                  "forex-pesa-admin-trend-up" : "forex-pesa-admin-trend-down"}>
                  {dashboardStats.todayTransactions >= dashboardStats.yesterdayTransactions ? "↑" : "↓"} 
                  vs yesterday
                </span>
              </div>
            </div>
            <div className="forex-pesa-admin-stat-icon">
              <FaHandHoldingUsd />
            </div>
          </div>
        </div>
  
        <div className="forex-pesa-admin-stat-card forex-pesa-admin-gradient-warning">
          <div className="forex-pesa-admin-stat-content">
            <div className="forex-pesa-admin-stat-info">
              <h6>Total Revenue</h6>
              <h2>KSH {dashboardStats.totalRevenue.toLocaleString()}</h2>
            </div>
            <div className="forex-pesa-admin-stat-icon">
              <FaChartLine />
            </div>
          </div>
        </div>
  
        <div className="forex-pesa-admin-stat-card forex-pesa-admin-gradient-danger">
          <div className="forex-pesa-admin-stat-content">
            <div className="forex-pesa-admin-stat-info">
              <h6>Total Approved Withdrawals</h6>
              <h2>KSH {approvedWithdrawals.toLocaleString()}</h2>
            </div>
            <div className="forex-pesa-admin-stat-icon">
              <FaMoneyBillWave />
            </div>
          </div>
        </div>
      </div>
  
      <div className="forex-pesa-admin-content-grid">
        <div className="forex-pesa-admin-card forex-pesa-admin-transactions">
          <div className="forex-pesa-admin-card-header">
            <h5>Recent Transactions</h5>
            <div className="forex-pesa-admin-card-actions">
              <button className="forex-pesa-admin-card-action-button">
                <FaEye /> View All
              </button>
            </div>
          </div>
          <div className="forex-pesa-admin-card-body">
            {loading ? (
              <div className="forex-pesa-admin-loading">
                <div className="forex-pesa-admin-spinner"></div>
                <p>Loading transactions...</p>
              </div>
            ) : recentTransactions.length === 0 ? (
              <div className="forex-pesa-admin-empty-state">
                <div className="forex-pesa-admin-empty-icon">
                  <FaRegNewspaper />
                </div>
                <p>No recent transactions found</p>
              </div>
            ) : (
              <div className="forex-pesa-admin-table-responsive">
                <table className="forex-pesa-admin-table">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Amount</th>
                      <th>Status</th>
                      <th>Receipt Number</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentTransactions.map((transaction) => (
                      <tr key={transaction.id}>
                        <td>
                          <div className="forex-pesa-admin-user-info">
                            <div className="forex-pesa-admin-user-avatar">
                              <FaUser />
                            </div>
                            <div className="forex-pesa-admin-user-details">
                              <div className="forex-pesa-admin-user-reference">{transaction.phoneNumber}</div>
                            </div>
                          </div>
                        </td>
                        <td className="forex-pesa-admin-amount">KSH {transaction.amount.toLocaleString()}</td>
                        <td>
                          <span className={`forex-pesa-admin-status forex-pesa-admin-status-${transaction.status.toLowerCase()}`}>
                            {transaction.status}
                          </span>
                        </td>
                        <td>{transaction.mpesaReceiptNumber}</td>
                        <td className="forex-pesa-admin-date">{format(new Date(transaction.transactionDate), 'PPp')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
 

  const renderDeposits = () => (
    <div className="adminpage-card">
      <div className="adminpage-card-header">
        <div className="adminpage-header-content">
          <h5 className="adminpage-title">Recent Deposits</h5>
          <div className="adminpage-button-group">
            <button className="adminpage-button adminpage-button-outline">
              <FaFileContract className="adminpage-icon" /> Export Report
            </button>
            <button className="adminpage-button adminpage-button-primary">
              <FaPlus className="adminpage-icon" /> New Deposit
            </button>
          </div>
        </div>
      </div>
      <div className="adminpage-card-body">
        {loading ? (
          <div className="adminpage-loading">Loading...</div>
        ) : error ? (
          <div className="adminpage-error">{error}</div>
        ) : (
          <div className="adminpage-table-container">
            <table className="adminpage-table">
               <thead>
              <tr>
                <th>Receipt Number</th>
                <th>Phone Number</th>
                <th>Amount</th>
                <th>Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
              <tbody>
                {deposits.map(deposit => (
                  <tr key={deposit.id}>
                    <td>{deposit.mpesaReceiptNumber}</td>
                    <td>{deposit.phoneNumber}</td>
                    <td>KSH {deposit.amount.toLocaleString()}</td>
                    <td>
                      {/* Safely format the date */}
                      {format(parseISO(deposit.transactionDate), 'PPp')}
                    </td>
                    <td>
                      <span className={`adminpage-status adminpage-status-${deposit.status.toLowerCase()}`}>
                        {deposit.status}
                      </span>
                    </td>
                    <td>
                      <div className="adminpage-actions">
                        <button 
                          className="adminpage-action-button adminpage-delete"
                          onClick={() => handleDeleteTransaction(deposit.id)}
                        >
                          <FaTrash /> Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          <div className="adminpage-pagination">
            <button 
              onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
              disabled={currentPage === 0}
            >
              Previous
            </button>
            <span>Page {currentPage + 1}</span>
            <button 
              onClick={() => setCurrentPage(prev => prev + 1)}
              disabled={deposits.length < itemsPerPage}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  </div>
  );

  const renderWithdrawals = () => (
    <div className="adminpage-card">
      <div className="adminpage-card-header">
        <div className="adminpage-header-content">
          <h5 className="adminpage-title">Pending Withdrawals</h5>
          <div className="adminpage-button-group">
            <button className="adminpage-button adminpage-button-outline">
              <FaFileContract className="adminpage-icon" /> Export Report
            </button>
          </div>
        </div>
      </div>
      <div className="adminpage-card-body">
      {loading ? (
        <div className="adminpage-loading">Loading...</div>
      ) : (
        <div className="adminpage-table-container">
          <table className="adminpage-table">
            <thead>
              <tr>
                <th>Order Number</th>
                <th>User</th>
                <th>Amount</th>
                <th>Amount to Receive</th>
                <th>Date</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
                {withdrawals.map(withdrawal => (
                  <tr key={withdrawal.id}>
                    <td>{withdrawal.orderNumber}</td>
                    <td>
                      <div className="adminpage-user-info">
                        <div className="adminpage-user-details">
                          <div>{withdrawal.email}</div>
                          <div className="adminpage-text-muted">{withdrawal.mobile}</div>
                        </div>
                      </div>
                    </td>
                    <td>KSH {withdrawal.requestedAmount.toLocaleString()}</td>
                    <td>KSH {withdrawal.amountToReceive.toLocaleString()}</td>
                    <td>
                      {/* Safely format the date */}
                      {format(parseISO(withdrawal.requestTime), 'PPp')}
                    </td>
                    <td>
                      <span className={`adminpage-status adminpage-status-${withdrawal.withdrawalStatus.toLowerCase()}`}>
                        {withdrawal.withdrawalStatus}
                      </span>
                    </td>
                    <td>
                      {withdrawal.withdrawalStatus === 'PENDING' && (
                        <div className="adminpage-actions">
                          <button 
                            className="adminpage-action-button adminpage-approve"
                            onClick={() => handleApproveWithdrawal(withdrawal.id)}
                          >
                            <FaCheckCircle /> Approve
                          </button>
                          <button 
                            className="adminpage-action-button adminpage-decline"
                            onClick={() => handleDeclineWithdrawal(withdrawal.id)}
                          >
                            <FaTimesCircle /> Decline
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
          </table>
          <div className="adminpage-pagination">
            <button 
              onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
              disabled={currentPage === 0}
            >
              Previous
            </button>
            <span>Page {currentPage + 1}</span>
            <button 
              onClick={() => setCurrentPage(prev => prev + 1)}
              disabled={withdrawals.length < itemsPerPage}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  </div>
  );


  const renderUsers = () => {
    const formatPhoneNumber = (mobile) => {
      if (!mobile) return '';
      
      // Remove any non-digit characters
      const cleanNumber = mobile.replace(/\D/g, '');
      
      // If number starts with 254, keep it as is
      if (cleanNumber.startsWith('254')) {
        return cleanNumber;
      }
      
      // If number starts with 01, remove 01 and add 254
      if (cleanNumber.startsWith('01')) {
        return `2541${cleanNumber.slice(2)}`;
      }
      
      // If number starts with 07, remove 07 and add 254
      if (cleanNumber.startsWith('07')) {
        return `2547${cleanNumber.slice(2)}`;
      }
      
      return cleanNumber;
    };
  
    const initiateWhatsAppChat = (mobile) => {
      const formattedNumber = formatPhoneNumber(mobile);
      window.open(`https://wa.me/${formattedNumber}`, '_blank');
    };
      
    const handleSuperLogin = async (userId) => {
      try {
        const response = await axios.post(
          `https://api.globallequityfinance.com/api/admin/super-login/${userId}`,
          null,
          { headers: { Authorization: token } }
        );
        
        // Store original admin token
        localStorage.setItem('adminToken', token);
        
        // Set new super login token
        const superLoginToken = response.data.access_token;
        localStorage.setItem('token', superLoginToken);
        
        // Store super login state
        localStorage.setItem('isSuperLogin', 'true');
        localStorage.setItem('originalUserId', userId);
        
        // Update auth context
        updateUserDetails(response.data.userDetails);
        
        // Redirect to user dashboard
        navigate('/user-dashboard');
        
      } catch (error) {
        console.error('Super login failed:', error);
        alert('Failed to access user account. Please try again.');
      }
    };
  
    return (
      <div className="forex-pesa-admin-users-container">
        <div className="forex-pesa-admin-users-header">
          <div className="forex-pesa-admin-users-header-left">
            <h2 className="forex-pesa-admin-users-title">User Management</h2>
            <p className="forex-pesa-admin-users-subtitle">
              Manage all system users and their accounts
            </p>
          </div>
          <div className="forex-pesa-admin-users-header-right">
            <div className="forex-pesa-admin-users-search">
              <input
                type="text"
                placeholder="Search by name, email, or mobile..."
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
                className="forex-pesa-admin-users-search-input"
              />
              <button className="forex-pesa-admin-users-search-button">
                <FaSearch />
              </button>
            </div>
            <button 
              className="forex-pesa-admin-users-export-button"
              onClick={handleExportContacts}
            >
              <FaFileContract className="forex-pesa-admin-users-button-icon" />
              <span className="forex-pesa-admin-users-button-text">Export Contacts</span>
            </button>
          </div>
        </div>
        
        <div className="forex-pesa-admin-users-content">
          {isLoading ? (
            <div className="forex-pesa-admin-users-loading">
              <div className="forex-pesa-admin-users-spinner"></div>
              <p>Loading users data...</p>
            </div>
          ) : error ? (
            <div className="forex-pesa-admin-users-error">
              <FaTimes className="forex-pesa-admin-users-error-icon" />
              <p>{error}</p>
            </div>
          ) : currentUsers.length === 0 ? (
            <div className="forex-pesa-admin-users-empty">
              <FaUsers className="forex-pesa-admin-users-empty-icon" />
              <p>No users found</p>
              <span>Try changing your search criteria</span>
            </div>
          ) : (
            <>
              <div className="forex-pesa-admin-users-table-wrapper">
                <table className="forex-pesa-admin-users-table">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th className="forex-pesa-admin-users-mobile-column">Mobile</th>
                      <th>WhatsApp</th>
                      <th>Status</th>
                      <th>Wallet</th>
                      <th className="forex-pesa-admin-users-date-column">Created On</th>
                      <th className="forex-pesa-admin-users-id-column">ID</th>
                      <th className="forex-pesa-admin-users-actions-column">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentUsers.map(user => (
                      <tr key={user.id} className="forex-pesa-admin-users-table-row">
                        <td>
                          <div className="forex-pesa-admin-users-user-info">
                            <div className="forex-pesa-admin-users-avatar">
                              <FaUser />
                            </div>
                            <div className="forex-pesa-admin-users-details">
                              <div className="forex-pesa-admin-users-name">{user.fullName || 'No Name'}</div>
                              <div className="forex-pesa-admin-users-email">{user.email || 'No Email'}</div>
                            </div>
                          </div>
                        </td>
                        <td className="forex-pesa-admin-users-mobile-column">{user.mobile || 'N/A'}</td>
                        <td>
                          <button 
                            className="forex-pesa-admin-users-whatsapp-button"
                            onClick={() => initiateWhatsAppChat(user.mobile)}
                            disabled={!user.mobile}
                            title={user.mobile ? `Chat with ${user.fullName}` : "No mobile number available"}
                          >
                            <FaWhatsapp className="forex-pesa-admin-users-whatsapp-icon" />
                            <span className="forex-pesa-admin-users-whatsapp-text">Chat</span>
                          </button>
                        </td>
                        <td>
                          <div className={`forex-pesa-admin-users-status forex-pesa-admin-users-status-${user.accountStatus?.toLowerCase() || 'unknown'}`}>
                            {user.accountStatus || 'Unknown'}
                          </div>
                        </td>
                        <td className="forex-pesa-admin-users-wallet">
                          KSH {user.wallet?.toLocaleString() || '0'}
                        </td>
                        <td className="forex-pesa-admin-users-date-column">
                          {user.createdOn ? format(parseISO(user.createdOn), 'PPp') : 'N/A'}
                        </td>
                        <td className="forex-pesa-admin-users-id-column">
                          <div className="forex-pesa-admin-users-id-badge">
                            #{user.id}
                          </div>
                        </td>
                        <td className="forex-pesa-admin-users-actions-column">
                          <div className="forex-pesa-admin-users-actions">
                            <div className="forex-pesa-admin-users-dropdown">
                              <button className="forex-pesa-admin-users-dropdown-toggle">
                                Actions <FaChevronDown className="forex-pesa-admin-users-dropdown-icon" />
                              </button>
                              <div className="forex-pesa-admin-users-dropdown-menu">
                                <button 
                                  className="forex-pesa-admin-users-dropdown-item"
                                  onClick={() => handleEditUser(user)}
                                >
                                  <FaEdit className="forex-pesa-admin-users-dropdown-icon" />
                                  Edit User
                                </button>
                                <button 
                                  className="forex-pesa-admin-users-dropdown-item"
                                  onClick={() => handleSuperLogin(user.id)}
                                >
                                  <FaUserShield className="forex-pesa-admin-users-dropdown-icon" />
                                  Super Login
                                </button>
                                <button 
                                  className="forex-pesa-admin-users-dropdown-item"
                                  onClick={() => {
                                    setSelectedUserForPassword(user);
                                    setShowPasswordReset(true);
                                  }}
                                >
                                  <FaKey className="forex-pesa-admin-users-dropdown-icon" />
                                  Reset Password
                                </button>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              
              <div className="forex-pesa-admin-users-pagination">
                <button
                  className="forex-pesa-admin-users-pagination-button"
                  onClick={() => setCurrentPage(prev => Math.max(0, prev - 1))}
                  disabled={currentPage === 0}
                >
                  <FaChevronLeft className="forex-pesa-admin-users-pagination-icon" />
                  Previous
                </button>
                <div className="forex-pesa-admin-users-pagination-info">
                  Page <span className="forex-pesa-admin-users-pagination-current">{currentPage + 1}</span>
                </div>
                <button
                  className="forex-pesa-admin-users-pagination-button"
                  onClick={() => setCurrentPage(prev => prev + 1)}
                  disabled={currentUsers.length < itemsPerPage}
                >
                  Next
                  <FaChevronRight className="forex-pesa-admin-users-pagination-icon" />
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };
  
  return (
    <div className="forex-pesa-admin-container">
      {/* Sidebar */}
      <aside className={`forex-pesa-admin-sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="forex-pesa-admin-sidebar-header">
          <div className="forex-pesa-admin-logo">
            <div className="forex-pesa-admin-logo-icon">GE</div>
            <h4>Global Equity</h4>
          </div>
          {isMobileView && (
            <button className="forex-pesa-admin-sidebar-close" onClick={toggleSidebar}>
              <FaTimes />
            </button>
          )}
        </div>
        
        <div className="forex-pesa-admin-sidebar-menu">
          <div className="forex-pesa-admin-sidebar-category">Main</div>
          <nav className="forex-pesa-admin-nav">
            <button 
              className={`forex-pesa-admin-nav-item ${activeTab === 'dashboard' ? 'active' : ''}`}
              onClick={() => handleMenuClick('dashboard')}
            >
              <div className="forex-pesa-admin-nav-icon">
                <FaTachometerAlt />
              </div>
              <span>Dashboard</span>
            </button>
            
            <button 
              className={`forex-pesa-admin-nav-item ${activeTab === 'users' ? 'active' : ''}`}
              onClick={() => handleMenuClick('users')}
            >
              <div className="forex-pesa-admin-nav-icon">
                <FaUsers />
              </div>
              <span>Users</span>
            </button>
            
            <div className="forex-pesa-admin-sidebar-category">Finance</div>
            
            <button 
              className={`forex-pesa-admin-nav-item ${activeTab === 'investments' ? 'active' : ''}`}
              onClick={() => handleMenuClick('investments')}
            >
              <div className="forex-pesa-admin-nav-icon">
                <FaChartLine />
              </div>
              <span>Investments</span>
            </button>
            
            <button 
              className={`forex-pesa-admin-nav-item ${activeTab === 'deposits' ? 'active' : ''}`}
              onClick={() => handleMenuClick('deposits')}
            >
              <div className="forex-pesa-admin-nav-icon">
                <FaCreditCard />
              </div>
              <span>Deposits</span>
            </button>
            
            <button 
              className={`forex-pesa-admin-nav-item ${activeTab === 'withdrawals' ? 'active' : ''}`}
              onClick={() => handleMenuClick('withdrawals')}
            >
              <div className="forex-pesa-admin-nav-icon">
                <FaMoneyBillWave />
              </div>
              <span>Withdrawals</span>
            </button>
            
            <button 
              className={`forex-pesa-admin-nav-item ${activeTab === 'expenses' ? 'active' : ''}`}
              onClick={() => handleMenuClick('expenses')}
            >
              <div className="forex-pesa-admin-nav-icon">
                <FaMoneyBillWave />
              </div>
              <span>Expenses</span>
            </button>
            
            <div className="forex-pesa-admin-sidebar-category">Management</div>
            
            <button 
              className={`forex-pesa-admin-nav-item ${activeTab === 'daily' ? 'active' : ''}`}
              onClick={() => handleMenuClick('daily')}
            >
              <div className="forex-pesa-admin-nav-icon">
                <FaLightbulb />
              </div>
              <span>Daily Rewards</span>
            </button>
            
            <button 
              className={`forex-pesa-admin-nav-item ${activeTab === 'proofs' ? 'active' : ''}`}
              onClick={() => handleMenuClick('proofs')}
            >
              <div className="forex-pesa-admin-nav-icon">
                <FaReceipt />
              </div>
              <span>Proofs</span>
            </button>
            
            <button 
              className={`forex-pesa-admin-nav-item ${activeTab === 'products' ? 'active' : ''}`}
              onClick={() => handleMenuClick('products')}
            >
              <div className="forex-pesa-admin-nav-icon">
                <FaRobot />
              </div>
              <span>Products</span>
            </button>

            <button 
              className={`forex-pesa-admin-nav-item ${activeTab === 'feeds' ? 'active' : ''}`}
              onClick={() => handleMenuClick('feeds')}
            >
              <div className="forex-pesa-admin-nav-icon">
                <FaClock />
              </div>
              <span>Feeds</span>
            </button>
            
            <button
              className="forex-pesa-admin-nav-item forex-pesa-admin-nav-whatsapp"
              // onClick={whatsapp}
            >
              <div className="forex-pesa-admin-nav-icon">
                <FaWhatsapp />
              </div>
              <span>WhatsApp Directory</span>
            </button>
          </nav>
        </div>
        
        <div className="forex-pesa-admin-sidebar-footer">
          <div className="forex-pesa-admin-user-profile">
            <div className="forex-pesa-admin-user-avatar">
              <FaUserShield />
            </div>
            <div className="forex-pesa-admin-user-details">
              <div className="forex-pesa-admin-user-name">Administrator</div>
              <div className="forex-pesa-admin-user-role">Super Admin</div>
            </div>
            <button className="forex-pesa-admin-logout-btn" onClick={logout}>
              <FaSignOutAlt />
            </button>
          </div>
        </div>
      </aside>
  
      {/* Mobile overlay */}
      {isMobileView && isSidebarOpen && (
        <div 
          className="forex-pesa-admin-sidebar-overlay"
          onClick={toggleSidebar}
        />
      )}
  
      {/* Main content area */}
      <main className={`forex-pesa-admin-main ${isSidebarOpen && !isMobileView ? 'shifted' : ''}`}>
        <header className="forex-pesa-admin-header">
          <div className="forex-pesa-admin-header-left">
            <button 
              className="forex-pesa-admin-mobile-toggle"
              onClick={toggleSidebar}
              aria-label="Toggle sidebar"
            >
              <FaBars />
            </button>
            <div className="forex-pesa-admin-page-title">
              <h1>{activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}</h1>
              <span className="forex-pesa-admin-breadcrumb">
                Home / {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
              </span>
            </div>
          </div>
          <div className="forex-pesa-admin-header-actions">
            <div className="forex-pesa-admin-search-global">
              <input type="text" placeholder="Search..." />
              <button className="forex-pesa-admin-search-btn">
                <FaSearch />
              </button>
            </div>
            <div className="forex-pesa-admin-header-buttons">
              <button className="forex-pesa-admin-header-button forex-pesa-admin-notification-btn">
                <FaBell />
                {notifications > 0 && (
                  <span className="forex-pesa-admin-notification-badge">
                    {notifications}
                  </span>
                )}
              </button>
              <button className="forex-pesa-admin-header-button forex-pesa-admin-globe-btn">
                <FaGlobe />
              </button>
              <div className="forex-pesa-admin-mobile-profile">
                <div className="forex-pesa-admin-mobile-avatar">
                  <FaUserShield />
                </div>
              </div>
            </div>
          </div>
        </header>
  
        <div className="forex-pesa-admin-content">
          {activeTab === 'dashboard' && renderDashboard()}
          {activeTab === 'deposits' && renderDeposits()}
          {activeTab === 'withdrawals' && renderWithdrawals()}
          {activeTab === 'users' && renderUsers()}
          {activeTab === 'daily' && <DailyRewards />}
          {activeTab === 'proofs' && <AdminProofs />}
          {activeTab === 'products' && <AddProduct />}
          {activeTab === 'feeds' && <AdminAddFeed />}
          {activeTab === 'investments' && <InvestmentManagement />}
          {activeTab === 'expenses' && <ExpenseManagement />}
        </div>
      </main>
  
      {/* Edit User Modal */}
      {editMode && (
        <div className="forex-pesa-admin-modal-overlay">
          <div className="forex-pesa-admin-modal">
            <div className="forex-pesa-admin-modal-header">
              <h5>Edit User Details</h5>
              <button className="forex-pesa-admin-modal-close" onClick={() => setEditMode(false)}>
                <FaTimes />
              </button>
            </div>
            <div className="forex-pesa-admin-modal-body">
              <div className="forex-pesa-admin-user-summary">
                <div className="forex-pesa-admin-user-big-avatar">
                  <FaUser />
                </div>
                <div className="forex-pesa-admin-user-info-summary">
                  <div className="forex-pesa-admin-user-name-big">{selectedUser?.fullName}</div>
                  <div className="forex-pesa-admin-user-id-display">ID: {selectedUser?.id}</div>
                </div>
              </div>
              
              <div className="forex-pesa-admin-form-group">
                <label>Name</label>
                <input 
                  type="text" 
                  value={selectedUser?.fullName} 
                  disabled 
                  className="forex-pesa-admin-form-control forex-pesa-admin-disabled"
                />
              </div>
              
              <div className="forex-pesa-admin-form-group">
                <label>Email</label>
                <input 
                  type="email" 
                  value={selectedUser?.email} 
                  disabled 
                  className="forex-pesa-admin-form-control forex-pesa-admin-disabled"
                />
              </div>
              
              <div className="forex-pesa-admin-form-group">
                <label>Mobile Number</label>
                <input
                  type="tel"
                  value={selectedUser?.mobile || ''}
                  onChange={(e) => setSelectedUser({
                    ...selectedUser,
                    mobile: e.target.value
                  })}
                  placeholder="Enter mobile number"
                  className="forex-pesa-admin-form-control"
                />
              </div>
              
              <div className="forex-pesa-admin-form-group">
                <label>Wallet Balance</label>
                <div className="forex-pesa-admin-input-group">
                  <span className="forex-pesa-admin-input-group-text">KSH</span>
                  <input
                    type="number"
                    value={editedBalance}
                    onChange={(e) => setEditedBalance(e.target.value)}
                    className="forex-pesa-admin-form-control"
                  />
                </div>
              </div>
              
              <div className="forex-pesa-admin-form-group">
                <label>Account Status</label>
                <select 
                  value={selectedUser?.accountStatus} 
                  onChange={(e) => setSelectedUser({
                    ...selectedUser,
                    accountStatus: e.target.value
                  })}
                  className="forex-pesa-admin-form-control"
                >
                  <option value="ACTIVE">Active</option>
                  <option value="INACTIVE">Inactive</option>
                  <option value="SUSPENDED">Suspended</option>
                </select>
              </div>
              
              <div className="forex-pesa-admin-form-group">
                <label>User Verification</label>
                <select
                  value="true"
                  onChange={(e) => setSelectedUser({
                    ...selectedUser,
                    isEnabled: true
                  })}
                  className="forex-pesa-admin-form-control"
                >
                  <option value="true">Enable</option>
                </select>
              </div>
            </div>
            
            <div className="forex-pesa-admin-modal-footer">
              <button 
                className="forex-pesa-admin-btn forex-pesa-admin-btn-light" 
                onClick={() => setEditMode(false)}
              >
                Cancel
              </button>
              <button 
                className="forex-pesa-admin-btn forex-pesa-admin-btn-primary" 
                onClick={() => handleUpdateUser(selectedUser.id, {
                  wallet: parseFloat(editedBalance),
                  accountStatus: selectedUser.accountStatus,
                  isEnabled: true,
                  mobile: selectedUser.mobile
                })}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
  
      {/* Password Reset Modal */}
      {showPasswordReset && selectedUserForPassword && (
        <PasswordResetModal
          user={selectedUserForPassword}
          onClose={() => {
            setShowPasswordReset(false);
            setSelectedUserForPassword(null);
          }}
          onPasswordReset={handlePasswordReset}
        />
      )}
  
      {/* Hidden CSV Download Link */}
      <CSVLink
        id="csvDownloadLink"
        data={users.map(user => ({
          Mobile: formatMobileForExport(user.mobile)
        }))}
        filename={`forex_pesa_mobile_numbers_${new Date().toISOString().split('T')[0]}.csv`}
        className="forex-pesa-admin-hidden-link"
      />

{/* Export Modal */}
{showExportModal && renderExportModal()}

<style jsx>{`

/* Dashboard Layout */
.forex-pesa-admin-dashboard {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Stats Grid */
.forex-pesa-admin-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

/* Stat Cards */
.forex-pesa-admin-stat-card {
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
}

.forex-pesa-admin-stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.forex-pesa-admin-stat-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  color: white;
  position: relative;
  z-index: 1;
}

.forex-pesa-admin-stat-info {
  flex: 1;
}

.forex-pesa-admin-stat-info h6 {
  margin: 0 0 5px;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.forex-pesa-admin-stat-info h2 {
  margin: 0 0 8px;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
}

.forex-pesa-admin-stat-trend {
  font-size: 13px;
  margin-top: 5px;
}

.forex-pesa-admin-trend-up {
  color: #a5ffce;
}

.forex-pesa-admin-trend-down {
  color: #ffcdd2;
}

.forex-pesa-admin-stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.2);
  font-size: 24px;
}

/* Gradients for stat cards */
.forex-pesa-admin-gradient-primary {
  background: linear-gradient(135deg, #2c3e50 0%, #4ca1af 100%);
}

.forex-pesa-admin-gradient-secondary {
  background: linear-gradient(135deg, #614385 0%, #516395 100%);
}

.forex-pesa-admin-gradient-tertiary {
  background: linear-gradient(135deg, #1a2980 0%, #26d0ce 100%);
}

.forex-pesa-admin-gradient-success {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.forex-pesa-admin-gradient-info {
  background: linear-gradient(135deg, #0082c8 0%, #667db6 100%);
}

.forex-pesa-admin-gradient-warning {
  background: linear-gradient(135deg, #f46b45 0%, #eea849 100%);
}

.forex-pesa-admin-gradient-danger {
  background: linear-gradient(135deg, #8e2de2 0%, #4a00e0 100%);
}

/* Content Grid */
.forex-pesa-admin-content-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

/* Card Styles */
.forex-pesa-admin-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.forex-pesa-admin-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.forex-pesa-admin-card-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.forex-pesa-admin-card-actions {
  display: flex;
  gap: 8px;
}

.forex-pesa-admin-card-action-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
}

.forex-pesa-admin-card-action-button:hover {
  background-color: #f8f9fa;
  color: #333;
}

.forex-pesa-admin-card-body {
  padding: 20px;
}

/* Table Styles */
.forex-pesa-admin-table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.forex-pesa-admin-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.forex-pesa-admin-table th {
  background-color: #f9fafb;
  color: #555;
  font-weight: 600;
  text-align: left;
  padding: 12px 16px;
  font-size: 14px;
  border-bottom: 2px solid #edf2f7;
}

.forex-pesa-admin-table td {
  padding: 14px 16px;
  font-size: 14px;
  color: #444;
  border-bottom: 1px solid #edf2f7;
  vertical-align: middle;
}

.forex-pesa-admin-table tr:last-child td {
  border-bottom: none;
}

.forex-pesa-admin-table tr:hover td {
  background-color: #f9fafb;
}

/* User info in table */
.forex-pesa-admin-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.forex-pesa-admin-user-avatar {
  width: 36px;
  height: 36px;
  background-color: #e9effd;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4361ee;
}

.forex-pesa-admin-user-details {
  display: flex;
  flex-direction: column;
}

.forex-pesa-admin-user-reference {
  font-weight: 500;
}

/* Status badges */
.forex-pesa-admin-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

.forex-pesa-admin-status-pending {
  background-color: #fff8e1;
  color: #f59e0b;
}

.forex-pesa-admin-status-completed, 
.forex-pesa-admin-status-success,
.forex-pesa-admin-status-approved {
  background-color: #e6f7ef;
  color: #10b981;
}

.forex-pesa-admin-status-failed,
.forex-pesa-admin-status-declined,
.forex-pesa-admin-status-rejected {
  background-color: #fee2e2;
  color: #ef4444;
}

.forex-pesa-admin-status-processing {
  background-color: #e6f4fd;
  color: #0ea5e9;
}

/* Loading state */
.forex-pesa-admin-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #666;
}

.forex-pesa-admin-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #4361ee;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Empty state */
.forex-pesa-admin-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #666;
}

.forex-pesa-admin-empty-icon {
  font-size: 48px;
  color: #cbd5e1;
  margin-bottom: 16px;
}

.forex-pesa-admin-amount {
  font-weight: 600;
  color: #333;
}

.forex-pesa-admin-date {
  color: #666;
  font-size: 13px;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .forex-pesa-admin-stats-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
  }
  
  .forex-pesa-admin-stat-content {
    padding: 16px;
  }
  
  .forex-pesa-admin-stat-info h2 {
    font-size: 24px;
  }
  
  .forex-pesa-admin-stat-icon {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .forex-pesa-admin-stats-grid {
    grid-template-columns: 1fr;
  }
  
  .forex-pesa-admin-card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .forex-pesa-admin-card-actions {
    width: 100%;
    justify-content: flex-end;
  }
}


// Retruurn

/* Main Layout */
.forex-pesa-admin-container {
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-color: #f6f8fa;
  position: relative;
  font-family: 'Inter', sans-serif;
}

/* Sidebar Styles */
.forex-pesa-admin-sidebar {
  width: 270px;
  height: 100vh;
  background-color: #ffffff;
  border-right: 1px solid #e9ecef;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
}

.forex-pesa-admin-sidebar.open {
  transform: translateX(0);
}

.forex-pesa-admin-sidebar-header {
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.forex-pesa-admin-logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.forex-pesa-admin-logo-icon {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #3a7bd5 0%, #1c3b8a 100%);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 16px;
}

.forex-pesa-admin-logo h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #333;
}

.forex-pesa-admin-sidebar-close {
  background: none;
  border: none;
  color: #9aa0a6;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  transition: all 0.2s;
}

.forex-pesa-admin-sidebar-close:hover {
  background-color: #f5f5f5;
  color: #333;
}

.forex-pesa-admin-sidebar-menu {
  flex: 1;
  padding: 15px 0;
  overflow-y: auto;
}

.forex-pesa-admin-sidebar-category {
  padding: 10px 20px;
  font-size: 12px;
  color: #8b939e;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-top: 10px;
}

.forex-pesa-admin-nav {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.forex-pesa-admin-nav-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  border-radius: 0;
  border: none;
  background: none;
  cursor: pointer;
  transition: all 0.2s;
  color: #555;
  text-align: left;
  position: relative;
  gap: 12px;
}

.forex-pesa-admin-nav-item:hover {
  background-color: #f5f7fa;
  color: #1a91ff;
}

.forex-pesa-admin-nav-item.active {
  background: rgba(26, 145, 255, 0.1);
  color: #1a91ff;
  font-weight: 500;
}

.forex-pesa-admin-nav-item.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #1a91ff;
  border-radius: 0 4px 4px 0;
}

.forex-pesa-admin-nav-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.forex-pesa-admin-nav-whatsapp {
  margin-top: 15px;
  background-color: #25d366;
  color: white;
  border-radius: 8px;
  margin-left: 15px;
  margin-right: 15px;
}

.forex-pesa-admin-nav-whatsapp:hover {
  background-color: #128c7e;
  color: white;
}

.forex-pesa-admin-sidebar-footer {
  padding: 15px 20px;
  border-top: 1px solid #f0f0f0;
}

.forex-pesa-admin-user-profile {
  display: flex;
  align-items: center;
  gap: 12px;
}

.forex-pesa-admin-user-avatar {
  width: 38px;
  height: 38px;
  background-color: #e9effd;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a91ff;
  font-size: 16px;
}

.forex-pesa-admin-user-details {
  flex: 1;
  min-width: 0;
}

.forex-pesa-admin-user-name {
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}

.forex-pesa-admin-user-role {
  color: #8b939e;
  font-size: 12px;
}

.forex-pesa-admin-logout-btn {
  background: none;
  border: none;
  color: #8b939e;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  transition: all 0.2s;
}

.forex-pesa-admin-logout-btn:hover {
  background-color: #f5f5f5;
  color: #e74c3c;
}

.forex-pesa-admin-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

/* Main Content Area */
.forex-pesa-admin-main {
  flex: 1;
  margin-left: 270px;
  transition: margin-left 0.3s ease;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.forex-pesa-admin-main.shifted {
  margin-left: 270px;
}

/* Header Styles */
.forex-pesa-admin-header {
  height: 70px;
  background-color: #ffffff;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 25px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.05);
}

.forex-pesa-admin-header-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.forex-pesa-admin-mobile-toggle {
  display: none;
  background: none;
  border: none;
  color: #555;
  font-size: 20px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: all 0.2s;
}

.forex-pesa-admin-mobile-toggle:hover {
  background-color: #f5f5f5;
}

.forex-pesa-admin-page-title {
  display: flex;
  flex-direction: column;
}

.forex-pesa-admin-page-title h1 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.forex-pesa-admin-breadcrumb {
  font-size: 12px;
  color: #8b939e;
}

.forex-pesa-admin-header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.forex-pesa-admin-search-global {
  position: relative;
  width: 250px;
}

.forex-pesa-admin-search-global input {
  width: 100%;
  height: 40px;
  border-radius: 20px;
  border: 1px solid #e9ecef;
  padding: 0 40px 0 15px;
  font-size: 14px;
  background-color: #f8f9fa;
  transition: all 0.2s;
}

.forex-pesa-admin-search-global input:focus {
  outline: none;
  border-color: #1a91ff;
  background-color: white;
  box-shadow: 0 0 0 3px rgba(26, 145, 255, 0.1);
}

.forex-pesa-admin-search-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #555;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.forex-pesa-admin-header-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.forex-pesa-admin-header-button {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background-color: #f8f9fa;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: all 0.2s;
}

.forex-pesa-admin-header-button:hover {
  background-color: #e9ecef;
  color: #1a91ff;
}

.forex-pesa-admin-notification-badge {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #e74c3c;
  color: white;
  font-size: 10px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.forex-pesa-admin-mobile-profile {
  display: none;
}

/* Content Area */
.forex-pesa-admin-content {
  flex: 1;
  padding: 25px;
  overflow-y: auto;
}

/* Modal Styles */
.forex-pesa-admin-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  backdrop-filter: blur(3px);
}

.forex-pesa-admin-modal {
  background-color: white;
  border-radius: 12px;
  width: 95%;
  max-width: 500px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.forex-pesa-admin-modal-header {
  padding: 20px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.forex-pesa-admin-modal-header h5 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.forex-pesa-admin-modal-close {
  background: none;
  border: none;
  color: #8b939e;
  font-size: 20px;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.forex-pesa-admin-modal-close:hover {
  background-color: #f5f5f5;
  color: #e74c3c;
}

.forex-pesa-admin-modal-body {
  padding: 20px;
}

.forex-pesa-admin-user-summary {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
}

.forex-pesa-admin-user-big-avatar {
  width: 60px;
  height: 60px;
  background-color: #e9effd;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a91ff;
  font-size: 24px;
}

.forex-pesa-admin-user-info-summary {
  flex: 1;
}

.forex-pesa-admin-user-name-big {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}

.forex-pesa-admin-user-id-display {
  font-size: 12px;
  color: #8b939e;
}

.forex-pesa-admin-form-group {
  margin-bottom: 20px;
}

.forex-pesa-admin-form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #555;
}

.forex-pesa-admin-form-control {
  width: 100%;
  height: 42px;
  border-radius: 8px;
  border: 1px solid #dfe3e8;
  padding: 0 15px;
  font-size: 14px;
  transition: all 0.2s;
}

.forex-pesa-admin-form-control:focus {
  outline: none;
  border-color: #1a91ff;
  box-shadow: 0 0 0 3px rgba(26, 145, 255, 0.1);
}

.forex-pesa-admin-form-control.forex-pesa-admin-disabled {
  background-color: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
}

.forex-pesa-admin-input-group {
  display: flex;
  align-items: center;
}

.forex-pesa-admin-input-group-text {
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  background-color: #f8f9fa;
  border: 1px solid #dfe3e8;
  border-radius: 8px 0 0 8px;
  border-right: none;
  font-size: 14px;
  color: #555;
}

.forex-pesa-admin-input-group .forex-pesa-admin-form-control {
  border-radius: 0 8px 8px 0;
  flex: 1;
}

.forex-pesa-admin-modal-footer {
  padding: 20px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.forex-pesa-admin-btn {
  height: 42px;
  padding: 0 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.forex-pesa-admin-btn-light {
  background-color: #f8f9fa;
  color: #555;
  border: 1px solid #dfe3e8;
}

.forex-pesa-admin-btn-light:hover {
  background-color: #e9ecef;
}

.forex-pesa-admin-btn-primary {
  background: linear-gradient(135deg, #3a7bd5 0%, #1c3b8a 100%);
  color: white;
}

.forex-pesa-admin-btn-primary:hover {
  box-shadow: 0 4px 10px rgba(58, 123, 213, 0.3);
  transform: translateY(-1px);
}

.forex-pesa-admin-hidden-link {
  display: none !important;
}

/* Responsive Styles */
@media (max-width: 992px) {
  .forex-pesa-admin-sidebar {
    transform: translateX(-100%);
    width: 240px;
  }

  .forex-pesa-admin-main {
    margin-left: 0;
  }

  .forex-pesa-admin-main.shifted {
    margin-left: 0;
  }

  .forex-pesa-admin-mobile-toggle {
    display: flex;
  }

  .forex-pesa-admin-search-global {
    width: 200px;
  }
}

@media (max-width: 768px) {
  .forex-pesa-admin-header {
    padding: 0 15px;
  }

  .forex-pesa-admin-page-title h1 {
    font-size: 18px;
  }

  .forex-pesa-admin-search-global {
    display: none;
  }

  .forex-pesa-admin-mobile-profile {
    display: block;
  }

  .forex-pesa-admin-mobile-avatar {
    width: 36px;
    height: 36px;
    background-color: #e9effd;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1a91ff;
    font-size: 16px;
  }

  .forex-pesa-admin-content {
    padding: 15px;
  }

  .forex-pesa-admin-modal {
    width: 95%;
  }
}

@media (max-width: 576px) {
  .forex-pesa-admin-sidebar {
    width: 100%;
  }

  .forex-pesa-admin-header-buttons {
    gap: 5px;
  }

  .forex-pesa-admin-header-button {
    width: 36px;
    height: 36px;
  }

  .forex-pesa-admin-breadcrumb {
    display: none;
  }
}

// Render Users 

/* Users Component Styles */
.forex-pesa-admin-users-container {
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0 1px 20px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Header Styles */
.forex-pesa-admin-users-header {
  padding: 24px 30px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.forex-pesa-admin-users-header-left {
  flex: 1;
  min-width: 250px;
}

.forex-pesa-admin-users-title {
  margin: 0 0 5px 0;
  font-size: 20px;
  font-weight: 600;
  color: #2d3748;
}

.forex-pesa-admin-users-subtitle {
  margin: 0;
  color: #718096;
  font-size: 14px;
}

.forex-pesa-admin-users-header-right {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
}

/* Search Styles */
.forex-pesa-admin-users-search {
  position: relative;
  min-width: 250px;
}

.forex-pesa-admin-users-search-input {
  height: 42px;
  width: 80%;
  padding: 0 40px 0 15px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background-color: #f7fafc;
  font-size: 14px;
  color: #4a5568;
  transition: all 0.2s ease;
}

.forex-pesa-admin-users-search-input:focus {
  outline: none;
  border-color: #3182ce;
  background-color: #fff;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.15);
}

.forex-pesa-admin-users-search-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #718096;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  transition: color 0.2s ease;
}

.forex-pesa-admin-users-search-input:focus + .forex-pesa-admin-users-search-button {
  color: #3182ce;
}

/* Export Button */
.forex-pesa-admin-users-export-button {
  height: 42px;
  padding: 0 16px;
  background: linear-gradient(45deg, #48bb78, #38b2ac);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.forex-pesa-admin-users-export-button:hover {
  box-shadow: 0 4px 10px rgba(56, 178, 172, 0.3);
  transform: translateY(-1px);
}

.forex-pesa-admin-users-button-icon {
  font-size: 16px;
}

/* Content Area */
.forex-pesa-admin-users-content {
  padding: 20px 30px 30px;
}

/* Loading State */
.forex-pesa-admin-users-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  color: #718096;
}

.forex-pesa-admin-users-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(66, 153, 225, 0.2);
  border-top-color: #3182ce;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Error State */
.forex-pesa-admin-users-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #e53e3e;
}

.forex-pesa-admin-users-error-icon {
  font-size: 40px;
  margin-bottom: 15px;
}

/* Empty State */
.forex-pesa-admin-users-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  color: #718096;
}

.forex-pesa-admin-users-empty-icon {
  font-size: 48px;
  margin-bottom: 15px;
  color: #cbd5e0;
}

.forex-pesa-admin-users-empty p {
  font-size: 18px;
  margin: 0 0 5px 0;
  font-weight: 500;
  color: #4a5568;
}

.forex-pesa-admin-users-empty span {
  font-size: 14px;
}

/* Table Styles */
.forex-pesa-admin-users-table-wrapper {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.forex-pesa-admin-users-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 800px;
}

.forex-pesa-admin-users-table th {
  padding: 16px 20px;
  text-align: left;
  background-color: #f7fafc;
  color: #4a5568;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  border-bottom: 1px solid #e2e8f0;
}

.forex-pesa-admin-users-table td {
  padding: 16px 20px;
  vertical-align: middle;
  border-bottom: 1px solid #e2e8f0;
  color: #2d3748;
  font-size: 14px;
}

.forex-pesa-admin-users-table-row:last-child td {
  border-bottom: none;
}

.forex-pesa-admin-users-table-row:hover {
  background-color: #f7fafc;
}

/* User Info */
.forex-pesa-admin-users-user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.forex-pesa-admin-users-avatar {
  width: 40px;
  height: 40px;
  background: linear-gradient(45deg, #3182ce, #63b3ed);
  color: white;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}

.forex-pesa-admin-users-details {
  display: flex;
  flex-direction: column;
}

.forex-pesa-admin-users-name {
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 2px;
}

.forex-pesa-admin-users-email {
  font-size: 13px;
  color: #718096;
}

/* Status Badge */
.forex-pesa-admin-users-status {
  display: inline-flex;
  padding: 6px 12px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

.forex-pesa-admin-users-status-active {
  background-color: #def7ec;
  color: #0e9f6e;
}

.forex-pesa-admin-users-status-inactive {
  background-color: #fef3c7;
  color: #d97706;
}

.forex-pesa-admin-users-status-suspended {
  background-color: #fee2e2;
  color: #dc2626;
}

.forex-pesa-admin-users-status-unknown {
  background-color: #e5e7eb;
  color: #6b7280;
}

/* WhatsApp Button */
.forex-pesa-admin-users-whatsapp-button {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #25d366;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.forex-pesa-admin-users-whatsapp-button:hover {
  background-color: #128c7e;
}

.forex-pesa-admin-users-whatsapp-button:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.7;
}

.forex-pesa-admin-users-whatsapp-icon {
  font-size: 14px;
}

/* Wallet Amount */
.forex-pesa-admin-users-wallet {
  font-weight: 600;
}

/* User ID Badge */
.forex-pesa-admin-users-id-badge {
  display: inline-flex;
  background-color: #edf2f7;
  color: #4a5568;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
}

/* Actions Dropdown */
.forex-pesa-admin-users-actions {
  display: flex;
  justify-content: flex-end;
}

.forex-pesa-admin-users-dropdown {
  position: relative;
}

.forex-pesa-admin-users-dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #edf2f7;
  color: #4a5568;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.forex-pesa-admin-users-dropdown-toggle:hover {
  background-color: #e2e8f0;
}

.forex-pesa-admin-users-dropdown-icon {
  font-size: 12px;
}

.forex-pesa-admin-users-dropdown-menu {
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  min-width: 180px;
  z-index: 10;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: all 0.2s ease;
}

.forex-pesa-admin-users-dropdown:hover .forex-pesa-admin-users-dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.forex-pesa-admin-users-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 15px;
  text-align: left;
  background: none;
  border: none;
  font-size: 13px;
  color: #4a5568;
  cursor: pointer;
  transition: all 0.2s ease;
}

.forex-pesa-admin-users-dropdown-item:hover {
  background-color: #f7fafc;
  color: #3182ce;
}

.forex-pesa-admin-users-dropdown-item:not(:last-child) {
  border-bottom: 1px solid #e2e8f0;
}

/* Pagination */
.forex-pesa-admin-users-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  gap: 15px;
}

.forex-pesa-admin-users-pagination-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: white;
  color: #4a5568;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.forex-pesa-admin-users-pagination-button:hover:not(:disabled) {
  background-color: #f7fafc;
  color: #3182ce;
  border-color: #cbd5e0;
}

.forex-pesa-admin-users-pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.forex-pesa-admin-users-pagination-icon {
  font-size: 12px;
}

.forex-pesa-admin-users-pagination-info {
  color: #718096;
  font-size: 14px;
}

.forex-pesa-admin-users-pagination-current {
  font-weight: 600;
  color: #3182ce;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .forex-pesa-admin-users-header {
    padding: 20px 25px;
  }
  
  .forex-pesa-admin-users-content {
    padding: 15px 25px 25px;
  }
  
  .forex-pesa-admin-users-mobile-column {
    display: none;
  }
}

@media (max-width: 768px) {
  .forex-pesa-admin-users-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .forex-pesa-admin-users-header-right {
    width: 100%;
    justify-content: space-between;
  }
  
  .forex-pesa-admin-users-search {
    flex: 1;
    max-width: 100%;
  }
  
  .forex-pesa-admin-users-date-column {
    display: none;
  }
  
  .forex-pesa-admin-users-id-column {
    display: none;
  }
  
  .forex-pesa-admin-users-button-text {
    display: none;
  }
  
  .forex-pesa-admin-users-export-button {
    width: 42px;
    padding: 0;
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .forex-pesa-admin-users-header {
    padding: 15px 20px;
  }
  
  .forex-pesa-admin-users-content {
    padding: 10px 20px 20px;
  }
  
  .forex-pesa-admin-users-whatsapp-text {
    display: none;
  }
  
  .forex-pesa-admin-users-whatsapp-button {
    width: 36px;
    height: 36px;
    padding: 0;
    justify-content: center;
  }
  
  .forex-pesa-admin-users-actions-column {
    padding-right: 10px;
  }
  
  .forex-pesa-admin-users-dropdown-toggle {
    width: 36px;
    height: 36px;
    padding: 0;
    justify-content: center;
  }
  
  .forex-pesa-admin-users-dropdown-toggle span {
    display: none;
  }
}


`}</style>


    </div>
  );
};

export default Admin;
